{
  "version": 1,
  "asset_id": "8f1ab2ec-6aed-4714-b352-3eff4a96b15a",
  "project_id": "1e2975bf-5ed0-490a-887a-32746528c0b1",
  "url": "/__l5e/assets-v1/8f1ab2ec-6aed-4714-b352-3eff4a96b15a/logo-infomoney.png",
  "r2_key": "a/v1/1e2975bf-5ed0-490a-887a-32746528c0b1/8f1ab2ec-6aed-4714-b352-3eff4a96b15a/logo-infomoney.png",
  "original_filename": "logo-infomoney.png",
  "size": 989,
  "content_type": "image/png",
  "created_at": "2026-09-21T21:42:13Z"
}
